import React, { useState } from 'react';
import { TabBar, TabType } from './components/TabBar';
import { OnboardingSprout } from './pages/OnboardingSprout';
import { OnboardingStart } from './pages/OnboardingStart';
import { OnboardingRole } from './pages/OnboardingRole';
import { OnboardingThemes } from './pages/OnboardingThemes';
import { OnboardingProjects } from './pages/OnboardingProjects';
import { OnboardingRecap } from './pages/OnboardingRecap';
import { SummitHome } from './pages/SummitHome';
import { TreeHome } from './pages/TreeHome';
import { MatchContainer } from './pages/MatchContainer';
import { ProfilePage } from './pages/ProfilePage';
import { User } from 'lucide-react';
type Screen = 'onboarding-sprout' | 'onboarding-start' | 'onboarding-role' | 'onboarding-themes' | 'onboarding-projects' | 'onboarding-recap' | 'summit' | 'tree-home' | 'match' | 'profilo';
export function App() {
  const [currentScreen, setCurrentScreen] = useState<Screen>('onboarding-sprout');
  const [activeTab, setActiveTab] = useState<TabType>('summit');
  const [fadeOverlay, setFadeOverlay] = useState(false);
  const handleTabChange = (tab: TabType) => {
    setActiveTab(tab);
    if (tab === 'summit') setCurrentScreen('summit');
    if (tab === 'albero') setCurrentScreen('tree-home');
    if (tab === 'match') setCurrentScreen('match');
    if (tab === 'profilo') setCurrentScreen('profilo');
  };
  const handleScanPress = () => {
    alert("Apre la fotocamera per scansionare il badge dell'altra persona!");
  };
  const handleOnboardingComplete = () => {
    setFadeOverlay(true);
    setTimeout(() => {
      setCurrentScreen('summit');
      setActiveTab('summit');
      setTimeout(() => {
        setFadeOverlay(false);
      }, 50);
    }, 600); // 600ms fade to black
  };
  const showTabBar = !currentScreen.startsWith('onboarding');
  return <div className="h-[100dvh] bg-[#0D0D0D] flex justify-center" data-id="element-0">
      <div className="w-full max-w-[480px] h-[100dvh] bg-[#0D0D0D] relative overflow-hidden flex flex-col" data-id="element-1">
        {/* Screen Content */}
        <div className={`flex-1 overflow-hidden min-h-0 ${showTabBar ? 'pb-[72px]' : ''}`} data-id="element-2">
          {currentScreen === 'onboarding-sprout' && <OnboardingSprout onContinue={() => setCurrentScreen('onboarding-start')} onSkipToApp={() => {
          setCurrentScreen('tree-home');
          setActiveTab('albero');
        }} data-id="element-3" />}

          {currentScreen === 'onboarding-start' && <OnboardingStart onContinue={() => setCurrentScreen('onboarding-role')} data-id="element-4" />}

          {currentScreen === 'onboarding-role' && <OnboardingRole onContinue={() => setCurrentScreen('onboarding-themes')} data-id="element-5" />}

          {currentScreen === 'onboarding-themes' && <OnboardingThemes onContinue={() => setCurrentScreen('onboarding-projects')} data-id="element-6" />}

          {currentScreen === 'onboarding-projects' && <OnboardingProjects onContinue={() => setCurrentScreen('onboarding-recap')} data-id="element-7" />}

          {currentScreen === 'onboarding-recap' && <OnboardingRecap onContinue={handleOnboardingComplete} data-id="element-8" />}

          {currentScreen === 'summit' && <SummitHome data-id="element-9" />}

          {currentScreen === 'tree-home' && <TreeHome onNavigateToMatch={() => handleTabChange('match')} onScanPress={handleScanPress} data-id="element-10" />}

          {currentScreen === 'match' && <MatchContainer onScanPress={handleScanPress} data-id="element-11" />}

          {currentScreen === 'profilo' && <ProfilePage data-id="element-12" />}
        </div>

        {/* Tab Bar */}
        {showTabBar && <TabBar activeTab={activeTab} onTabChange={handleTabChange} data-id="element-13" />}

        {/* Fade Overlay for Transition */}
        <div className="absolute inset-0 bg-[#0D0D0D] z-[100] pointer-events-none transition-opacity duration-500 ease-in-out" style={{
        opacity: fadeOverlay ? 1 : 0
      }} data-id="element-14" />
      </div>
    </div>;
}